import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom'

import Sidenav from './sidenav/index'
import Navbar from '../../components/navbar'
import PasswordContent from './passwordContent/index'
import MainVault from './mainVault/MainVault'
import Spinner from '../../components/spinner/Spinner'

import { auth } from '../../firebase/config'


import { connect } from 'react-redux'
import changeStatus from '../../actions/userStatus'



class Main extends Component {
    state = {
        loading: true
    }
    componentDidMount() {
        let self = this
        auth.onAuthStateChanged(user => {
            if (!user) {
                self.props.history.push('/')
                localStorage.removeItem('uid')
                self.props.changeUser(false)
            } else {
                let name = user.email || user.displayName
                self.props.changeUser(true, user.uid, name)
                localStorage.setItem('uid', user.uid)
                self.setState({
                    loading: false
                })
            }
        })
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2" style={{ background: 'black', color: 'white', minHeight: '100vh' }}>
                        {
                            this.state.loading
                                ? <Spinner margin='100px auto' />
                                : this.props.user
                                    ? <Sidenav />
                                    : null
                        }
                    </div>
                    <div className="col-md-10 m-0 p-0">
                        <Navbar name={this.props.user.name} />
                        <Switch>
                            <Route path="/main" exact component={MainVault} />
                            <Route exact path="/main/:vault" component={PasswordContent} />
                        </Switch>
                    </div>
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.userStatus
        }
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeUser: (data, uid, name) => dispatch(changeStatus(data, uid, name))
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(Main);